module.exports = __webpack_public_path__ + "media/fonts/KumbhSans-Light-2c0aa226c795f0235c96bebb45a262c5.ttf";